<template>
    <div class="average-check-in-graph">
        <div class="graph-header locale-font">
            <div class="graph-title">
                {{ $vuetify.lang.t('$vuetify.averageCheckInGraph.title') }}
            </div>
            <div class="graph-sub-title">
                {{ $vuetify.lang.t('$vuetify.averageCheckInGraph.weekly') }}
            </div>
        </div>
        <line-chart
            v-if="show"
            :options="optionsLineCollection"
            :chart-data="dataLineCollection"
        ></line-chart>
    </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart.js'
export default {
    name: 'AverageCheckInGraph',

    components: {
        LineChart
    },
    computed: {
        days () {
            return [
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.mon'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.tue'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.wed'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.thu'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.fri'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.sat'),
                this.$vuetify.lang.t('$vuetify.averageCheckInGraph.sun')
            ]
        },
        dataLineCollection () {
            return this.init()
        }
    },
    data () {
        return {
            show: false,
            groupList: [],
            averageTimeList: [],
            branchId: '',
            selectedGroup: '',
            optionsLineCollection: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            // one step = 1 hours
                            stepSize: 3600000,

                            callback: function (value, index, values) {
                                const dateTime = new Date(value)
                                // display time HH:MM
                                return dateTime.toLocaleTimeString('th-TH').slice(0, 5)
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label: function (tooltipsItem, data) {
                            const timeDisplay = new Date(tooltipsItem.yLabel)
                            // display time HH:MM
                            return timeDisplay.toLocaleTimeString('th-TH').slice(0, 5)
                        }
                    }
                },
                legend: {
                    display: false
                }
            }
        }
    },

    methods: {
        init () {
            this.show = true
            return {
                labels: this.days,
                datasets: [
                    {
                        label: 'Average Time',
                        backgroundColor: '#6c98ba',
                        borderColor: '#6c98ba',
                        fill: false,
                        data: this.averageTimeList,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    }
                ]
            }
        },

        async getData () {
            this.show = false
            const res = await this.axios.get('dashboard/average-check-in-graph')
            if (res && res.data && res.data.status === 'ok') {
                // format data to time stamp for add value to graph
                const times = res.data.data.map(time => {
                    // if avg is not null
                    if (time) {
                        return new Date(`2022-01-01 ${time}`).valueOf()
                    }
                    return null
                })

                this.averageTimeList = times
                this.show = true
            }
        }
    },

    mounted () {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.average-check-in-graph {
    border-radius: 15px;
    box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    padding: 15px;
}
.graph-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .graph-title {
        font-size: 24px;
    }

    .graph-sub-title {
        font-size: 14px;
    }
}
</style>
